import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import StyledImage from "./styled-image"
import Cta from "./cta"
import Carousel from "./carousel"

export default function SpaMenus({ props, exclude }) {
  const heading = props?.heading
  const content = props?.content
  const data = useStaticQuery(graphql`
    {
      allWpSpaMenu(sort: {menuOrder: ASC}) {
        nodes {
          title
          uri
          excerpt
          featuredImage {
            node {
              altText
              localFile {
                publicURL
                extension
                childImageSharp {
                  gatsbyImageData(width: 1444)
                }
              } 
            }
          }
          spaMenu {
            icon {
              altText 
              localFile {
                publicURL
              }
            }
            hidePageLink
            overrideLink {
              target
              url
            }
          }
        }
      }
    }
  `)
  const spaMenus = data?.allWpSpaMenu.nodes?.filter(({ uri, spaMenu }) => {
    return !exclude?.includes(uri) && spaMenu?.hidePageLink !== true
  }) || []
  const carouselSettingsOverrides = {
    slidesToShow: 1,
    slidesToScroll: 1,
    className: `slick-arrows-centered slick-arrows-wide -mx-[1px]`,
  }

  return (
    <section className="bg-banner-gradient/10 py-12">
      <div className="container" id="hotel-rooms">
        <div className="max-w-4xl mx-auto md:text-center mb-10">
          {heading ? <h2 className="mb-2">{heading}</h2> : null}
          {content ? <div className="parsed-content" dangerouslySetInnerHTML={{ __html: content }} /> : null}
        </div>
        {spaMenus ?
          <>
            <div className="md:hidden mb-6 px-2">
              <Carousel settingsOverrides={carouselSettingsOverrides}>
                {spaMenus.map((hotelRoom, index) => {
                  return (
                    <SpaMenuCard props={hotelRoom} key={index} />
                  )
                })
                }
              </Carousel>
            </div>

            <ul className={`hidden md:grid md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-8 lg:gap-10 2xl:gap-16 mb-10`}>
              {spaMenus.map((hotelRoom, index) => {
                return (
                  <li key={index}>
                    <SpaMenuCard props={hotelRoom} />
                  </li>
                )
              })
              }
            </ul>
          </> : null}
      </div>
    </section>
  )
}
const SpaMenuCard = ({ props }) => {
  const { title, excerpt, featuredImage, spaMenu } = props
  const uri = spaMenu?.overrideLink?.url || props.uri
  const image = featuredImage?.node
  const { hidePageLink, icon } = spaMenu

  return (
    <div className={`mx-auto md:mx-0 max-w-xs sm:max-w-sm h-full flex gap-4 flex-col justify-between md:max-w-none bg-white sm:shadow-spread shadow-spread-xs p-5 relative rounded`}>
      <div className={`grid gap-3`}>
        {icon?.localFile?.publicURL ? <img src={icon.localFile.publicURL} alt={icon.alt} className="h-[3.25rem] w-auto" /> : null}
        {title ? <h3 className='h2'>
          <Link to={uri} className="text-body hover:text-black">
            {title}
          </Link>
        </h3> : null}
        {image ? (
          <Link to={uri} className="block">
            <StyledImage
              image={image}
              objectFit="cover"
              className={`w-full aspect-video`} />
          </Link>
        ) : null}
        {excerpt && (
          <div className="parsed-content text-wire">
            <div
              dangerouslySetInnerHTML={{
                __html: excerpt,
              }}
            />
          </div>
        )}
      </div>
      {!hidePageLink ? <div>
        <Cta to={uri} className="btn btn-ruby btn-sm">
          View Menu
        </Cta>
      </div> : null}
    </div>

  )
}
